module.exports = __webpack_public_path__ + "static/media/12.74e5405a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/12.jpg
// module id = 702
// module chunks = 0